import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | About Us – Our Story',
  description:
    'Discover Avia’ About Us: our culture, vision, mission, growth story and more. Join our spirited journey in skill gaming!',
  keywords: ['about us'],
  path: 'about',
}

export const AboutMetaData = generateMetadata(MetaData)
